import React, { useEffect, useRef } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideAlerter = (callback: () => void, checkInside: boolean = false) => {
  const callbackRef = useRef<() => void>();
  const innerRef: React.RefObject<HTMLDivElement> = useRef(null);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClick(e: any) {
      if (innerRef.current && callbackRef.current) {
        if (checkInside) {
          callbackRef.current();
        } else if (!innerRef.current.contains(e.target)) {
          callbackRef.current();
        }
      }
    }
    // Bind the event listener
    document.addEventListener("click", handleClick);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClick);
    };
  }, [checkInside]);

  return innerRef;
};
